module.exports = new __parcel__URL__("favicon-temp-assets.32f0aa73.png").toString();